import SelectInput, { SelectProps as MuiSelectProps } from '@mui/material/Select';
import clsx from 'clsx';
import React from 'react';
import { useInputGroupContext } from './InputGroup';
import styles from './InputGroupSelect.module.scss';

export type InputGroupSelectProps = Omit<MuiSelectProps, 'variant'>;

export const InputGroupSelect = React.forwardRef<HTMLSelectElement, InputGroupSelectProps>(
    (props, ref) => {
        const { setFocused } = useInputGroupContext();

        const handleFocus = (e: React.FocusEvent<HTMLInputElement>) => {
            setFocused(true);
            props.onFocus?.(e);
        };

        const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
            setFocused(false);
            props.onBlur?.(e);
        };

        return (
            <SelectInput
                variant="outlined"
                {...props}
                ref={ref}
                onFocus={handleFocus}
                onBlur={handleBlur}
                MenuProps={{ style: { maxHeight: 250 }, ...props.MenuProps }}
                className={clsx(styles.root, props.className)}
            />
        );
    }
);

InputGroupSelect.displayName = 'InputGroupSelect';
